import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import { format, parseISO } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { Vortex } from 'react-loader-spinner'

function MfFundProfile() {
  const { BaseURL } = useContext(URLstateContext);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingshow, setloadingshow] = useState(false);
  // const [type, settype] = useState(['In']);
  // const [DataMfHoldingdropMfcode, setDataMfHoldingdropMfcode] = useState([]);
  // const [CategorymfCode, setCategoryDividend] = useState('-');
  // const [valueschemename, setValueschemename] = useState([]);
  let getDataFundProfile, PageSize = 5;
  let navigate = useNavigate();
  useEffect(() => {
    setloadingshow(true);
    const getUrl = BaseURL + "MfFundProfile";
    fetch(`${getUrl}/8`)
      .then((response) => response.json())
      .then((dataFundProfile) => {
        getDataFundProfile = dataFundProfile.data;
        setData(getDataFundProfile);
        setloadingshow(false);
        // console.log(getDataFundProfile, "getDataFundProfile")
      })
      .catch((error) => {
      });
  }, []);

  const currentTableData = useMemo(() => {
    if (data != null && data != []) {
      const firstPageIndex = (currentPage - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      if (data != null && data != []) {
        if (data.length > 0) {
          return data.slice(firstPageIndex, lastPageIndex);
        }
      }
    }
  }, [currentPage, data]);
  return (
    <>
      <div className='market-inner-common market-mf-main'>
        <div className='market-header'>
          <h4>Fund Profile</h4>
          <span className="moreContent" onClick={()=>{navigate("/MutualFund/Fund-Profile")}}>See More</span>
        </div>
        <Container className="add-border table-box">
        <div className='mf-common fund-performance-main'>
          {/* <div class="gainer-dates">
            <ul>
              <li className='active'>1D</li>
              <li>1W</li>
              <li>1M</li>
              <li>3M</li>
              <li>6M</li>
              <li>1Y</li>
            </ul>
          </div>
          <div class="holdings-select">
            <select>
              <option>Select Fund House</option>
            </select>
          </div> */}
          <div className='mf-table table-responsive gainer-table'>
            <table className='table'>
              <thead>
                <tr>
                  <th className='text-left'>Fund House</th>
                  <th className='text-right'>Incorporation Date</th>
                  <th className='text-center'>Fund Type</th>
                  <th className='text-right'>Total Assets* (Rs Cr.)</th>
                  <th className='text-right'>As On Date</th>
                </tr>
              </thead>
              {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
              <tbody>
              {(data != null) && data.map(({ LNAME,STARTED_ON,SumOfTOTNAV,FUND_TYPE,dateas}) => (
                <tr>
                  <td className='text-left'>{LNAME}</td>
                  <td className='text-right'>{format(parseISO(STARTED_ON.split('T')[0] != null ? STARTED_ON.split('T')[0] :0), 'dd-MMM-yyyy') }</td>
                  <td className='text-center'>{FUND_TYPE}</td>
                  <td className='text-right'>{SumOfTOTNAV.toFixed(2)}</td>
                  <td className='text-right'>{format(parseISO(dateas.split('T')[0] != null ? dateas.split('T')[0] :0), 'dd-MMM-yyyy') }</td>
                </tr>
              ))}
              </tbody>
            </table>
            {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
          </div>
          {/* {(data != null && data != []) ?
            <Pagination
              className="pagination-bar_peer"
              currentPage={currentPage}
              totalCount={(data.length != null) ? data.length : 0}
              pageSize={PageSize}
              onPageChange={page => setCurrentPage(page)}
            /> : <p className="errorPeer"> No Data Found !!! </p>} */}
        </div>
        </Container>
      </div>
    </>
  )
}

export default MfFundProfile